import { InputsMediator } from './inputs-mediator';

// Factory function for manipulating game actions
function GameInputsMediator() {
  let instance: InputsMediator | null = (window as any).inputs_mediator || null;

  // Check if browser supports gamepad
  if (!navigator.getGamepads) {
    console.error('Gamepad API not supported');
    return null as unknown as InputsMediator;
  }

  if (!instance) {
    instance = new InputsMediator();
    (window as any).inputs_mediator = instance;
  }

  return instance;
}

export { GameInputsMediator, type InputsMediator };
